import { Injectable } from "@angular/core";
import * as myGlobals from "../globalPath";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { LanguageService } from "src/app/services/language.service";
import { EmailSettingModel } from "src/app/models/EmailSettings/email-setting-model";
import { guestTempOrder } from "src/app/models/order/guest_temp_order";
import { LocationDataViewModel } from "src/app/models/location-data-vm";

@Injectable()
export class LookupService {
  getQuotationDetailsByRefNo: any;
  constructor(private http: HttpClient, private languageService: LanguageService) {
  }

  logout(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlIdentity +
      myGlobals.logoutUrl +
      "?userId=" +
      obj.userId +
      "&deviceId=" +
      obj.deviceId,
      {}
    );
  }

  createUser(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlIdentity + myGlobals.createUserUrl,
      obj
    );
  }

  updateUser(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlIdentity + myGlobals.updateUserUrl,
      obj
    );
  }

  getAllAvailability(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.availabilitysUrl
    );
  }

  getAvailabilities(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.availabilitysWithoutLangUrl
    );
  }

  getAllAvailabilityWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.availabilitysUrlWithBlock
    );
  }

  blockAvailabilty(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.blockAvailability + id
    );
  }

  getBuildingTypes(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.buildingTypesUrl
    );
  }

  getBuildingTypesUrlWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.buildingTypesUrlWithBlock
    );
  }

  blockBuildingType(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.blockBuildingType + id
    );
  }

  getDispatcherFormensWithTeams(dispatcherId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement +
      myGlobals.getDispatcherFormensWithTeamsUrl +
      "?dispatcherId=" +
      dispatcherId
    );
  }

  getTeamsState(dispatcherId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement +
      myGlobals.getTeamsState +
      "/" +
      dispatcherId
    );
  }
  getTeamOrdersByTeamId(model: any): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.getTeamOrdersByTeamIdUrl,
      model
    );
  }
  ghghghghg
  getAllAreasDataManagement(): Observable<any> {
    return this.http.get(myGlobals.BaseUrlDataManagement + myGlobals.areasUrl);
  }

  getAllAreasWithBlocked(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.areasUrlWithBlocked
    );
  }

  blockArea(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.blockArea + id
    );
  }

  getAllAreasDataManagementPaginated(pageNoSize): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.areasUrl,
      pageNoSize
    );
  }

  getAllAttendanceStates(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.attendanceStatusUrl
    );
  }

  getAllAttendanceStatesWithBlocked(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.attendanceStatusUrlWithBlock
    );
  }

  blockAttendanceStatus(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.blockAttendanceStatus + id
    );
  }
  ///OrderStatus
  blockOrderStatus(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.blockOrderStatus + id
    );
  }

  getCompanyCodes(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.companyCodeUrl
    );
  }

  getCompanyCodesWithBlockedList(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.companyCodeUrl
    );
  }

  getCompanyCodesWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.companyCodeUrlWithBlock
    );
  }

  blockCompanyCode(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.blockCompanyCode + id
    );
  }

  getContractTypes(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.contractTypesUrl
    );
  }

  getContractTypesWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.contractTypesUrlWithBlock
    );
  }

  blockContractType(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.blockContractType + id
    );
  }

  getCostCenter(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.costCenterUrl
    );
  }

  getCostCenterWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.costCenterUrlWithBlock
    );
  }

  blockCostCenter(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.blockCostCenter + id
    );
  }

  getDivision(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.divisionUrl
    );
  }

  getDivisionWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.divisionUrlWithBlock
    );
  }

  blockDivision(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.blockDivision + id
    );
  }

  getDivisionEnUrl(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.divisionEnUrl
    );
  }

  getGovernorates(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.governoratesUrl
    );
  }

  getGovernoratesWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.governoratesUrlWithBlock
    );
  }

  blockGovernorate(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.blockGovernorate + id
    );
  }

  getShift(): Observable<any> {
    return this.http.get(myGlobals.BaseUrlDataManagement + myGlobals.shiftUrl);
  }

  getShiftWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.shiftUrlWithBlock
    );
  }

  blockShift(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.blockShift + id
    );
  }

  get materialIssueApprovalCycle(): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.getMaterialIssueApprovalCycle);
  }

  getlanguages(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.languagesUrl
    );
  }

  getlanguagesWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.languagesUrlWithBlock
    );
  }

  blockLanguage(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.blockLanguage + id
    );
  }

  getOrderStatus(): Observable<any> {
    return this.http.get(myGlobals.orderStatus);
  }

  getOrderByCode(code): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getOrderByCode + code
    );
  }

  bulkAssignOrders(obj) {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.orderBulkAssign,
      obj
    );
  }

  getOrderProgress(payload): Observable<any> {
    return this.http.post(

      myGlobals.BaseUrlOrderManagementNew + myGlobals.orderProgresWithOffesetsUrl, payload
    );
  }

  addUserDevice(key): Observable<any> {
    const deviceData = {
      deveiceId: key,
      fk_AppUser_Id: JSON.parse(localStorage.getItem("AlghanimCurrentUser"))
        .data.userId,
    };
    return this.http.post(
      myGlobals.BaseUrlIdentity + myGlobals.addUserDeviceUrl,
      deviceData
    );
  }

  getAllProblems(): Observable<any> {
    return this.http.get(myGlobals.allOrderProblemsUrl);
  }

  getAllProblemsLocalized(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.allProbsLocalized
    );
  }

  getAllProblemsLocalizedWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.allProbsLocalizedWithBlock
    );
  }

  blockProblem(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.blockProblem + id
    );
  }

  getAllDivisions(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.allDivisionsUrl
    );
  }

  getAllDivisionsWithBlockedList(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.allDivisionsWithBlockedUrl
    );
  }

  getAllOrderTypes(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.allOrderTypesUrl
    );
  }

  getAllOrderTypesWithBlockedList(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.allOrderTypesWithBlockedUrl
    );
  }

  getAllAreas(): Observable<any> {
    return this.http.get(myGlobals.allAreasDispatcher);
  }

  getDisAllOrders(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getOrdersByDis + id
    );
  }

  getAllOrderProblems(): Observable<any> {
    return this.http.get(myGlobals.allOrderProblemsUrl);
  }

  postOrderType(orderType): Observable<any> {
    return this.http.post(myGlobals.postOrderTypeUrl, orderType);
  }

  postOrderStatus(orderState): Observable<any> {
    return this.http.post(myGlobals.postOrderStateUrl, orderState);
  }

  filterOrders(filterObj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.filterMapOrdersURL,
      filterObj
    );
  }

  postMapOrderFilter(params): Observable<any> {
    //api/Order/OrderFilter
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.postMapOrderFilterURL,
      params
    );
  }

  postAllOrdersBoardOrderFilter(params): Observable<any> {
    // dispatcher board filter function
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.postAllOrdersBoardOrderFilterURL,
      params
    );
  }

  postBoardOrderFilter(params): Observable<any> {
    // dispatcher board filter function
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.postBoardOrderFilterURL,
      params
    );
  }

  postBoardUnAssignedOrderFilter(params): Observable<any> {
    // dispatcher board filter function
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.postUnassignedOrdersBoardFilterURL,
      params
    );
  }
  postOrderProblems(objectProblems): Observable<any> {
    return this.http.post(myGlobals.postOrderProblems, objectProblems);
  }

  ////////////////////////////////////////// New //////////////////////////////////////////////////
  getAllRoles(): Observable<any> {
    return this.http.get(myGlobals.BaseUrlIdentity + myGlobals.rolesUrl);
  }
  postArea(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.postAreasUrl,
      obj
    );
  }
  editArea(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.putAreaLanguageUrl,
      obj
    );
  }
  getAreaLangById(areaId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.areaLanguageByIdUrl + areaId
    );
  }
  deleteArea(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.deleteAreaUrl + id
    );
  }

  postProblem(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.addProbURL,
      obj
    );
  }
  postAttendanceStates(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.postAttendanceStates,
      obj
    );
  }
  editAttendanceStates(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.putAttendanceStatesUrl,
      obj
    );
  }
  deleteAttendanceStates(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.deleteAttendanceStatesUrl + id
    );
  }
  getAttendanceStatesById(attendId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement +
      myGlobals.attendanceStatesByIdUrl +
      attendId
    );
  }
  //OrderStatus
  getOrderStatusById(OrderStatusId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.attendanceStatesByIdUrl +
      OrderStatusId
    );
  }
  postAvailability(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.postAvailability,
      obj
    );
  }
  editAvailability(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.putAvailabilityUrl,
      obj
    );
  }
  deleteAvailability(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.deleteAvailabilityUrl + id
    );
  }
  getAvailabilityById(avaliblId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement +
      myGlobals.availabilityByIdUrl +
      avaliblId
    );
  }
  postBuildingTypes(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.postBuildingTypes,
      obj
    );
  }
  editBuildingTypes(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.putBuildingTypesUrl,
      obj
    );
  }
  deleteBuildingTypes(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.deleteBuildingTypesUrl + id
    );
  }
  getBuildingTypesById(buildId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.buildingTypesByIdUrl + buildId
    );
  }
  postCompanyCode(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.postCompanyCode,
      obj
    );
  }
  editCompanyCode(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.putCompanyCodeUrl,
      obj
    );
  }
  deleteCompanyCode(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.deleteCompanyCodeUrl + id
    );
  }
  getCompanyCodeById(companyId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.companyCodeByIdUrl + companyId
    );
  }
  postContractType(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.postContractTypes,
      obj
    );
  }
  editContractTypes(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.putContractTypesUrl,
      obj
    );
  }


  deleteContractTypes(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.deleteContractTypesUrl + id
    );
  }

  deleteContractTypesNew(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.deleteContractTypesUrlNew + id
    );
  }

  getContractTypeById(contId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.contractTypesByIdUrl + contId
    );
  }
  postCostCenter(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.postCostCenter,
      obj
    );
  }
  editCostCenter(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.putCostCenterUrl,
      obj
    );
  }
  deleteCostCenter(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.deleteCostCenterUrl + id
    );
  }
  getCostCenterById(costId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.CostCentersByIdUrl + costId
    );
  }
  postDivision(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.postDivision,
      obj
    );
  }
  editDivision(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.putDivisionUrl,
      obj
    );
  }
  deleteDivision(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.deleteDivisionUrl + id
    );
  }
  getDivisionById(DivisionId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.divisionByIdUrl + DivisionId
    );
  }
  postGovernorates(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.postGovernorates,
      obj
    );
  }
  editGovernorates(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.putGovernoratesUrl,
      obj
    );
  }
  deleteGovernorates(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.deleteGovernoratesUrl + id
    );
  }
  getGovernoratesById(govId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.governoratesByIdUrl + govId
    );
  }
  postShift(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.postShift,
      obj
    );
  }
  editShift(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.putShiftUrl,
      obj
    );
  }
  deleteShift(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.deleteShiftUrl + id
    );
  }
  getShiftById(govId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.ShiftByIdUrl + govId
    );
  }
  postLanguages(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.postLanguages,
      obj
    );
  }
  editLanguages(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.putLanguagesUrl,
      obj
    );
  }
  deleteLanguages(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.deleteLanguagesUrl + id
    );
  }

  postAreaLanguages(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.postAreaLanguage,
      obj
    );
  }
  editAreaLanguages(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.putAreaLanguageUrl,
      obj
    );
  }
  deleteAreaLanguages(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.deleteAreaLanguagesUrl + id
    );
  }
  postAttendanceStatesLanguages(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.postAttendanceStatesLanguage,
      obj
    );
  }
  editAttendanceStatesLanguages(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement +
      myGlobals.putAttendanceStatesLanguageUrl,
      obj
    );
  }
  deleteAttendanceStatesLanguages(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement +
      myGlobals.deleteAttendanceStatesLanguagesUrl +
      id
    );
  }
  //////OrderStatus/////
  postOrderStatusLanguages(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.postOrderStatusLanguage,
      obj
    );
  }
  editOrderStatusLanguages(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.putOrderStatusLanguageUrl,
      obj
    );
  }
  deleteOrderStatusLanguages(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.deleteAttendanceStatesLanguagesUrl +
      id
    );
  }
  /////Working Type
  editWorkingTypeLanguages(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.putWorkingTypeLanguageUrl,
      obj
    );
  }
  //
  editOrderSubStatusLanguages(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.putOrderSubStatusLanguageUrl,
      obj
    );
  }

  postAvailabilityLanguage(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.postAvailabilityLanguage,
      obj
    );
  }
  editAvailabilityLanguages(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.putAvailabilityLanguageUrl,
      obj
    );
  }
  postBuildingTypesLanguage(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.postBuildingTypesLanguage,
      obj
    );
  }
  editBuildingTypesLanguages(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.putBuildingTypesLanguageUrl,
      obj
    );
  }
  postCompanyCodeLanguage(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.postCompanyCodeLanguage,
      obj
    );
  }
  editCompanyCodeLanguages(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.putCompanyCodeLanguageUrl,
      obj
    );
  }
  postContractTypesLanguage(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.postContractTypesLanguage,
      obj
    );
  }
  editContractTypesLanguages(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.putContractTypesLanguageUrl,
      obj
    );
  }
  postCostCenterLanguage(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.postCostCenterLanguage,
      obj
    );
  }
  editCostCenterLanguages(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.putLang_CostCenterLanguageUrl,
      obj
    );
  }
  postDivisionLanguage(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.postDivisionLanguage,
      obj
    );
  }
  editDivisionLanguages(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.putDivisionLanguageUrl,
      obj
    );
  }
  postGovernoratesLanguage(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.postGovernoratesLanguage,
      obj
    );
  }
  editGovernoratesLanguages(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.putGovernoratesLanguageUrl,
      obj
    );
  }
  postShiftLanguage(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.postShiftLanguage,
      obj
    );
  }
  editShiftLanguages(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.putShiftUrl,
      obj
    );
  }
  editProblem(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.putProblemLanguageUrl,
      obj
    );
  }

  ///////////User Management//////////
  getAllUserAdmin(): Observable<any> {
    return this.http.get(myGlobals.BaseUrlIdentity + myGlobals.adminUserUrl);
  }
  getUserById(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlIdentity + myGlobals.getrUserById + id
    );
  }
  postUser(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlIdentity + myGlobals.postUserUrl,
      obj
    );
  }
  editUser(obj): Observable<any> {
    return this.http.put(myGlobals.BaseUrlIdentity + myGlobals.putUserUrl, obj);
  }
  getAllDispatchers(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getDispatcherUrl
    );
  }
  getAllDispatchersWithBlockedList(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getDispatcherWithBlockedUrl
    );
  }
  getDispatcherBySuperId(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.getDispatcherBySuperIdUrl +
      id
    );
  }
  getAllDispatchersWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getDispatcherUrlWithBlock
    );
  }
  blockDispatcher(id): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlUserManagementNew + myGlobals.blockDispatcher + id,
      {}
    );
  }
  getDispatcherById(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getDispatcherUserById + id
    );
  }
  getDispatcherBySuper(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.getDispatchersUserBySuper +
      id
    );
  }
  postUserDispatcher(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlUserManagementNew + myGlobals.postUserDispatcherUrl,
      obj
    );
  }
  editUserDispatcher(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlUserManagementNew + myGlobals.putUserDispatcherUrl,
      obj
    );
  }
  getAllDrivers(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getDriverUrl
    );
  }
  getAllIcAgents(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getICAgentUrl
    );
  }
  getAllSuperVisor(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getSuperVisorUrl
    );
  }
  getSuperVisorByDivisionId(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.getSuperVisorByDivisionIdUrl +
      id
    );
  }
  getAllSuperVisorWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getSupervisorUrlWithBlock
    );
  }
  blockSupervisor(id): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlUserManagementNew + myGlobals.blockSupervisor + id,
      {}
    );
  }
  postSuperVisor(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlUserManagementNew + myGlobals.postSupervisorUrl,
      obj
    );
  }
  editUserSuperVisor(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlUserManagementNew + myGlobals.putUserSupervisorUrl,
      obj
    );
  }
  getSuperVisorById(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getSupervisorUserById + id
    );
  }
  getSuperVisor(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getSupervisorUser + id
    );
  }
  getSupervisorByUserId(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.getSupervisorUserByUserId +
      id
    );
  }
  getSuperVisorByDivision(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.getSupervisorUserBydivison +
      id
    );
  }
  postDriver(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlUserManagementNew + myGlobals.postDriverUrl,
      obj
    );
  }
  editUserDiver(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlUserManagementNew + myGlobals.putUserDriverUrl,
      obj
    );
  }
  editUserManager(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlUserManagementNew + myGlobals.putUserMangerUrl,
      obj
    );
  }
  editUserMateialController(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.putUserMaterialControllerUrl,
      obj
    );
  }
  getDriverById(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getDriverUserById + id
    );
  }
  getManagerById(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getMangerUserById + id
    );
  }
  getMaterialControllerById(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.getMateialControllerUserById +
      id
    );
  }
  getDriverByDivision(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getDriverUserBydivison + id
    );
  }
  getAllEngineers(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getEngineerUrl
    );
  }
  getEngineersByDivisionId(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.getEngineersByDivisionIdUrl +
      id
    );
  }
  getAllEngineersWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getEngineerUrlWithBlock
    );
  }
  blockEngineer(id): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlUserManagementNew + myGlobals.blockEngineer + id,
      {}
    );
  }
  postEngineer(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlUserManagementNew + myGlobals.postEngineerUrl,
      obj
    );
  }
  editUserEngineer(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlUserManagementNew + myGlobals.putUserEngineerUrl,
      obj
    );
  }
  getEngineerById(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getEngineerUserById + id
    );
  }
  getEngineerByDivision(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.getEngineerUserBydivison +
      id
    );
  }
  getAllTechnicians(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getTechnicianUrl
    );
  }
  //By Shaimaa Sayed
  getAllAssignedTechnicians(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getAssignedTechnicianUrl
    );
  }
  getAllTechniciansWithBlockedList(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getTechnicianUrlWithBlock
    );
  }
  blockTechnician(id): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlUserManagementNew + myGlobals.blockTechnician + id,
      {}
    );
  }
  postTechnician(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlUserManagementNew + myGlobals.postTechnicianUrl,
      obj
    );
  }
  editUserTechnician(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlUserManagementNew + myGlobals.putUserTechnicianUrl,
      obj
    );
  }
  getTechnicianById(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getTechnicianUserById + id
    );
  }
  getAllForemans(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getForemanUrl
    );
  }
  getAllForemansWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getForemanUrlWithBlock
    );
  }
  blockForeman(id): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlUserManagementNew + myGlobals.blockForeman + id,
      {}
    );
  }
  postForeman(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlUserManagementNew + myGlobals.postForemanUrl,
      obj
    );
  }
  editUserForeman(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlUserManagementNew + myGlobals.putUserForemanUrl,
      obj
    );
  }
  getForemanById(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getForemanUserById + id
    );
  }

  /**
   * finance user by id
   *
   *
   * @param id
   */
  getFinanceById(id): Observable<any> {
    return this.http.get(myGlobals.BaseUrlUserManagementNew + myGlobals.getFinanceUser + id);
  }

  getContractAdministratorById(id): Observable<any> {
    return this.http.get(myGlobals.BaseUrlUserManagementNew + myGlobals.getContractAdministratorUser + id);
  }

  getForemanByDispatcher(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.getFormanUserByDispatcher +
      id
    );
  }
  getAllMangaer(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getManagerUrl
    );
  }
  getAllMangaerWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getManagerUrlWithBlock
    );
  }
  blockManager(id): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlUserManagementNew + myGlobals.blockManager + id,
      {}
    );
  }
  postManager(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlUserManagementNew + myGlobals.postManagerUrl,
      obj
    );
  }
  postMaterialController(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlUserManagementNew + myGlobals.postMaterialControllerUrl,
      obj
    );
  }
  getAllMaterial(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getMaterialUrl
    );
  }

  /**
   * finance users
   *
   *
   */
  getAllFinanceUsers(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getAllFinanceUsers
    );
  }
  getAllContractAdministratorUsers(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getContractAdministratorUrlWithBlock
    );
  }

  /**
   * finance roles
   *
   *
   */
  getRolesAndPermissionsForFinance(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getRolesAndPermissionsForFinance
    );
  }
  getRolesInType(roleType): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getRolesInCertainType + roleType
    );
  }

  getRolesAndPermissionsForContractAdministrator(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getRolesAndPermissionsForContractAdministrator
    );
  }






  getRolesOfAdmin(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getRolesOfAdmin
    );
  }
  AllEmailSettingGrouped(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.AllEmailSettingGrouped
    );
  }

  GetAllRolesForEmailSettings(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.GetAllRolesForEmailSettings
    );
  }

  GetAllNotifyChannels(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.GetAllNotifyChannels
    );
  }

  getAllMaterialWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getMaterialUrlWithBlock
    );
  }
  blockMaterialController(id): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.blockMaterialController +
      id,
      {}
    );
  }

  /**
   * block finance user
   *
   *
   * @param id
   */
  blockFinanceUser(id: number): Observable<any> {
    return this.http.put(myGlobals.BaseUrlUserManagementNew + myGlobals.blockFinanceUser + id, {});
  }

  blockContractAdministratorUser(id: number): Observable<any> {
    return this.http.put(myGlobals.BaseUrlUserManagementNew + myGlobals.blockContractAdministratorUser + id, {});
  }

  resetUserPassword(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlIdentity + myGlobals.resetPassword,
      obj
    );
  }
  deactivateUserInIdentity(name): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlIdentity + myGlobals.deactivateUserByUsername + name
    );
  }

  ///////////Team Management//////////
  getAllUnassignedMempers(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getUnassignedMempersUrl
    );
  }

  getAllUnassignedMempersByDivision(divisionId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.getUnassignedMempersByDivisionIdUrl +
      divisionId
    );
  }

  getAllUnassignedVehicles(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getUnassignedVehiclesUrl
    );
  }

  getTechnicianByPF(pf, divisionId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.getTechnicianByPFUrl +
      pf +
      "&division=" +
      divisionId
    );
  }

  getTeamByName(name): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getTeamByNameUrl + name
    );
  }

  getVehicleByPlateNo(PlateNo): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.getVehicleByPlateNoUrl +
      PlateNo
    );
  }

  addVehcile(PlateNo): Observable<any> {
    let obj = {
      plate_no: PlateNo,
    };
    return this.http.post(
      myGlobals.BaseUrlUserManagementNew + myGlobals.addVehicleURL,
      obj
    );
  }

  updateVehcile(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlUserManagementNew + myGlobals.updateVehicleURL,
      obj
    );
  }

  getAllVehicles(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getVehicleAllUrl
    );
  }

  getMembersByTeamId(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getMembersByTeamIdUrl + id
    );
  }

  getTeamByDispatcherById(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getByDispatcherByIdUrl + id
    );
  }

  getTeams(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getTeams
    );
  }

  getAllTeams(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getAllTeams
    );
  }
  getAllTeamsWithOutMembers(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getAllTeamsWithOutMembers
    );
  }

  postTeam(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlUserManagementNew + myGlobals.postTeam,
      obj
    );
  }

  updateTeam(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlUserManagementNew + myGlobals.updateTeam,
      obj
    );
  }

  assginMemberToTeam(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.assignTeamMember +
      "?teamId=" +
      obj.teamId +
      "&memberId=" +
      obj.memberId,
      null
    );
  }

  assginMembersToTeam(teamId: number, members: any[], defaultTech: number): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.assignTeamMembers + teamId + `/${defaultTech}`,
      members
    );
  }
  reassignTeamToDispatcher(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.reassignTeamToDispatcher +
      "?teamId=" +
      obj.teamId +
      "&dispatcherId=" +
      obj.dispatcherId,
      null
    );
  }
  unAssginMember(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.unassignedMember +
      "?memberId=" +
      obj.memberId,
      null
    );
  }

  unAssginMembers(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlUserManagementNew + myGlobals.unassignedMembersURL,
      obj
    );
  }

  deleteTeam(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.deleteTeamURL.replace("{id}", id)
    );
  }

  ///////////dispatcherSetting////////////
  getALLareasEnUrl(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.areasEnUrl
    );
  }

  getAllAreasWithBlockedList(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.areasWithblocked
    );
  }

  getAllOrderProblem(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.OrderProblem
    );
  }

  getAllOrderProblemWithBlockedList(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.OrderProblemWithBlocked
    );
  }

  getALLDispatcherSettingsList(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.getALLDispatcherSettingsListUrl
    );
  }

  getAllDispatcherSettings(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.disSettingUrl
    );
  }

  getAllDispatcherSettingspaginated(pageobj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlUserManagementNew + myGlobals.disSettingUrls,
      pageobj
    );
  }

  getDispatcherSettingById(disId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.getDispatcherSettingById.replace("{0}", disId)
    );
  }

  GetMultiAreasAndProblemsbyDispatcherId(disId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.GetMultiAreasAndProblemsbyDispatcherId.replace(
        "{dispatcherId}",
        disId
      )
    );
  }

  deleteDisDetting(disId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.deleteDispatcherSetting.replace("{0}", disId)
    );
  }

  postDispatcherAllProblemsandArea(Disobj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.postDispatcherAllProblemsandArea,
      Disobj
    );
  }

  UpdateMulitWithAreasAndOrderProblems(Disobj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.UpdateMulitWithAreasAndOrderProblemsUrl,
      Disobj
    );
  }

  AddWithMultiEmailSettings(emailSettings: EmailSettingModel[]): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.AddWithMultiEmailSettings,
      emailSettings
    );
  }


  AddMulitWithAreasAndOrderProblems(Disobj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.AddMulitWithAreasAndOrderProblemsUrl,
      Disobj
    );
  }


  getALLDispatcherSettingsbyGroup(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew +
      myGlobals.getALLDispatcherSettingsbyGroupIdUrl.replace("{GroupId}", id)
    );
  }

  postProblemArea(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlUserManagementNew + myGlobals.postProblemArea,
      obj
    );
  }

  ////////////////////// time sheet ///////////////////

  GetTimeSheet(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.TimeSheetUrlgetdate,
      // "https://dispatcher-order-dev-api.chevrolet-autline-dev.p.azurewebsites.net/api/OrderAction/GetTimeSheet"
      obj
    );
  }

  exportTimeSheetResults(obj): Observable<any> {
    return this.http.post(
      // "https://dispatcher-order-dev-api.chevrolet-autline-dev.p.azurewebsites.net/api/OrderAction/GetTimeSheetExcelExport"
      myGlobals.BaseUrlOrderManagementNew + myGlobals.exportTimeSheetResultsUrl,
      obj
    );
  }

  exportTimeSheetResultsAsClosedXml(model: any, optionHeader?: any): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.exportTimeSheetResultsAsClosedXmlUrl,
      model, optionHeader

    );
  }


  exportingTimeSheetWay(model: any): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.exportingTimeSheetWayUrl,
      model

    );
  }

  //////////////////order management////////////////////////////
  getAllUnAssignedOrdersForDispatcher(dispatcherId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.unAssignedOrdersForDispatcherUrl +
      dispatcherId
    );
  }

  getAllAssignedOrdersForDispatcher(dispatcherId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.assignedOrdersForDispatcherUrl +
      dispatcherId
    );
  }

  postAllUnAssignedOrdersForDispatcher(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.unAssignedOrdersForDispatcherPaginatedUrl,
      obj
    );
  }

  postAllUnAssignedOrdersForDispatcherFilter(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.unAssignedOrdersForDispatcherPaginatedFilterUrl,
      obj
    );
  }

  //////////////////Supervisor////////////////////////////
  getAllUnAssignedOrdersForSupervisor(Id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.unAssignedOrdersForSupervisorUrl +
      Id
    );
  }

  postAllUnAssignedOrdersForSupervisor(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.unAssignedOrdersForSupervisorPaginatedUrl,
      obj
    );
  }

  postAllUnAssignedOrdersForSupervisorFilter(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.unAssignedOrdersForSupervisorFilteredPaginatedUrl,
      obj
    );
  }

  postAllAssignedOrdersForSupervisorFilter(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.assignedOrdersForSupervisorFilteredPaginatedUrl,
      obj
    );
  }

  getAllAssignedOrdersForSupervisor(Id, size): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.assignedOrdersForSupervisorUrl +
      Id +
      "&pageSize=" +
      size
    );
  }

  unAssginOrderFromDispatcher(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.unAssigndOrdersFromDispatcherUrl,
      obj
    );
  }

  assginOrderToDispatcher(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.assigndOrdersToDispatcherUrl,
      obj
    );
  }

  assginOrder(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.assigndOrdersUrl,
      obj
    );
  }

  unAssginOrder(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.unAssigndOrdersUrl,
      obj
    );
  }

  rankTeamOrders(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.rankTeamOrdersUrl,
      obj
    );
  }

  rankTeamOrderskByDrag(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.rankTeamOrderskByDragUrl,
      obj
    );
  }

  rankTeamOrdersWithoutNotification(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.rankTeamOrdersWithoutNitificationUrl,
      obj
    );
  }

  getOrderDetails(orderId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.orderDetailsUrl.replace("{ID}", orderId)
    );
  }

  getAllSubOrderStatus(statusId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.orderSubStatus + statusId
    );
  }

  getAllSubOrderStatusWithBlock(statusId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.orderSubStatusWithBlock +
      statusId
    );
  }
  // getAllSubOrderStatusWithBlock():Observable<any> {
  //   return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.orderSubStatusWithBlock);
  // }

  blockOrderSubstatus(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.blockSubstatus + id
    );
  }

  updateOrderSubStatus(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.updateOrderSubStatus,
      obj
    );
  }

  addOrderSubStatus(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.addOrderSubStatus,
      obj
    );
  }

  changeOrderStatus(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.orderChangeStatus,
      obj
    );
  }

  updateOrder(order): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.updateOrderUrl,
      order
    );
  }

  getLocationByPaci(paciCode): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlLocation + myGlobals.getPaciLocationUrl + paciCode
    );
  }

  getAllPriority(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getAllPriorityUrl
    );
  }

  getAllStatus(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getAllStatusUrl
    );
  }

  getAllStatusWithBlockedList(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getAllStatusWithBlockedUrl
    );
  }

  getAllStatusWithBlockedWithoutArchivedStatus(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getAllStatusWithBlockedWithoutArchivedStatus
    );
  }

  getCompanyCode(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.getCompanyCodeUrl
    );
  }

  getTeamsForForemen(data): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getTeamsForForemen,
      data
    );
  }
  getTeamsWithBlockedForForemen(data): Observable<any> {
    return this.http.get(myGlobals.BaseUrlUserManagementNew + myGlobals.getTeamsWithBlockedForForemen, data);
  }
  getTeamsWithBlockedForForemenAsPost(data): Observable<any> {
    return this.http.post(myGlobals.BaseUrlUserManagementNew + myGlobals.getTeamsWithBlockedForForemenasPostRequest, data);
  }

  getFilteredOrdersForPrint(data): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getFilteredOrdersForPrint,
      data
    );
  }

  deleteOrderType(id): Observable<any> {
    return this.http.delete(myGlobals.deleteOrderTypeUrl + id);
  }

  deleteOrderStatus(id): Observable<any> {
    return this.http.delete(myGlobals.deleteOrderStatusUrl + id);
  }

  removeProblem(id): Observable<any> {
    return this.http.delete(myGlobals.removeProblemUrl + id);
  }

  updateOrderStatus(status): Observable<any> {
    return this.http.put(myGlobals.updateOrderStatusUrl, status);
  }

  updateOrderType(type): Observable<any> {
    return this.http.put(myGlobals.updateOrderTypeUrl, type);
  }

  updateOrderProgressLookUp(progress): Observable<any> {
    return this.http.put(myGlobals.updateOrderProgressUrl, progress);
  }

  updateOrderProblemsLookUp(problem): Observable<any> {
    return this.http.put(myGlobals.updateOrderProblemsUrl, problem);
  }

  /////////////////////////// notification center/////////////////////////

  postNotificationCenter(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.PostNotificationCenterURL,
      obj
    );
  }

  getNotificationCenterById(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.GetNotificationCenterByIdURL.replace("{id}", id)
    );
  }

  getNotificationCenterCount(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.GetNotificationCenterByIdURL +
      id
    );
  }

  getNotificationCenterByIds(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.PostNotificationCenterGetByIdsURL,
      obj
    );
  }

  GetAllNotificationCenter(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.GetAllNotificationCenterURL
    );
  }

  updateNotificationCenterItem(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.PutNotificationCenterItemURL,
      obj
    );
  }

  ChangeReadFlagNotificationCenterItem(id: number): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.ChangeReadFlagNotificationCenterItemURL +
      id
    );
  }

  ChangeActionFlagNotificationCenterItem(id: number): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.ChangeActionFlagNotificationCenterItemURL +
      id
    );
  }

  AddNotificationCenter(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.PostAddNotificationCenterURL,
      obj
    );
  }

  AddMultiNotificationCenter(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.PostAddMultiNotificationCenterURL,
      obj
    );
  }

  getAllPaginatedNotificationCenter(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.GetAllPaginatedNotificationCenterURL,
      obj
    );
  }

  getAllPaginatedByPredicateNotificationCenter(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.GetAllPaginatedByPredicateNotificationCenterURL,
      obj
    );
  }
  //Added By Shaimaa Sayed
  getAllNotificationCenterByTechAndOrderCode(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.getAllNotificationCenterByTechAndOrderCode,
      obj
    );
  }
  //getAllNotificationCenterByTechAndOrderCode(obj):Observable<any> {
  //return this.http.post(myGlobals.BaseUrlOrderManagementNew + myGlobals.getAllNotificationCenterByTechAndOrderCode, obj);
  //}

  deleteNotificationCenter(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.DeleteNotificationCenterURL.replace("{id}", id)
    );
  }

  GetNotificationCenterCountByRecieverId(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.GetNotificationCenterCountByRecieverIdURL.replace(
        "{recieverId}",
        id
      )
    );
  }

  MarkAllAsReadByRecieverIdURL(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.MarkAllAsReadByRecieverIdURL +
      id
    );
  }

  putNotificationCenterChangeTeamOrderRank(acceptChange, obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.PutNotificationCenterChangeTeamOrderRankURL.replace(
        "{acceptChange}",
        acceptChange
      ),
      obj
    );
  }

  postNotificationCenterFilteredByDate(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.PostNotificationCenterFilteredByDate,
      obj
    );
  }

  //////////////////////////map settings

  getMapSettings(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.getMapSettingsURL + id
    );
  }

  putMapSettings(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.putMapSettingsURL,
      obj
    );
  }

  getAllWorkingTypes(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getWorkingTypes
    );
  }

  getAllWorkingTypesWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getWorkingTypesWithBlock
    );
  }
  //getAllOrderStatusWithBlock
  getAllOrderStatusWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getOrderStatusWithBlock
    );
  }
  blockWorkingType(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.blockWorkingType + id
    );
  }

  addWorkingType(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.addWorkingType,
      obj
    );
  }

  updateWorkingType(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.updateWorkingType,
      obj
    );
  }

  deleteAllOrders(): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.deleteAllOrders
    );
  }

  deleteDispatcherSettings(): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlUserManagementNew + myGlobals.deleteAllDispatcherSettings
    );
  }

  deleteAllUsersFromUserManagement(): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlUserManagementNew + myGlobals.deleteAllManagementUsers
    );
  }

  deleteAllUsersFromIdentity(): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlIdentity + myGlobals.deleteAllUsers
    );
  }

  getOrdersManagementReport(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.postOrdersManagementReport,
      obj
    );
  }

  exportOrdersManagementReport(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.exportOrdersManagementReport,
      obj
    );
  }

  getMonthlyRepairReport(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getMonthlyRepairReportUrl,
      obj
    );
  }

  exportMonthlyRepairReport(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.exportMonthlyRepairReportUrl,
      obj, { responseType: 'blob' }
    );
  }

  exportingMonthlyRepairReportWay(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.exportingMonthlyRepairReportWayUrl,
      obj
    );
  }

  exportMonthlyRepairReportToEmail(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.exportMonthlyRepairReportToEmailUrl,
      obj
    );
  }
  //////////////////////customer Types
  //getAllCustomerTypesWithBlock
  getAllCustomerTypesWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.allCustomerTypesLang
    );
  }


  GetCustomerIdByPhone(phone: string): Observable<Responce<number>> {
    return this.http.get<Responce<number>>(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.GetCustomerIdByPhone + phone
    );
  }






  addCustomerType(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.addCustomerTypeURL,
      obj
    );
  }
  blockCustomerType(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.blockCustomerType + id
    );
  }

  editCustomerType(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.putCustomerTypeLanguageUrl,
      obj
    );
  }

  getCustomerType(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.getAllCustomerTypeUrl
    );
  }
  getCustomerTypeWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.getAllCustomerTypewithBlockUrl
    );
  }

  //////////////////////machine Types
  getAllMachineTypesWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.allMachineTypesLang
    );
  }

  addMachineType(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.addMachineTypeURL,
      obj
    );
  }
  blockMachineType(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.blockMachineType + id
    );
  }

  editMachineType(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.putMachineTypeLanguageUrl,
      obj
    );
  }

  getMachineTypes(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.getAllMachineTypeUrl
    );
  }

  //////////////////////Phone Types
  getAllPhoneTypesWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.allPhoneTypesLang
    );
  }

  addPhoneType(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.addPhoneTypeURL,
      obj
    );
  }
  blockPhoneType(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.blockPhoneType + id
    );
  }

  editPhoneType(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.putPhoneTypeLanguageUrl,
      obj
    );
  }

  getPhoneType(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.getAllPhoneTypeUrl
    );
  }
  ////////////////////////////////////////////Customer
  getAllCustomersByPaging(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.allCustomersbyPaging,
      obj
    );
  }

  searchCustomersByPaging(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.searchCustomersbyPaging,
      obj
    );
  }
  searchCustomersOfCallCenter(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.searchCustomersOfCallCenter,
      obj
    );
  }
  getCustomerContracts(customerId): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.getCustomerContracts + customerId)
  }
  getGovAreas(govId): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.GetAreasListByGovId + govId)
  }
  getCustomerContractInvoices(customerId): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.getCustomerContractInvoices + customerId)
  }
  getCustomerAllContracts(obj): Observable<any> {

    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getCustomerAllContracts,
      obj
    );
  }
  getCustomerAllContractUnits(obj): Observable<any> {

    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.GetContractAllUnitsOfCutomer,
      obj
    );
  }
  viewOrderInvoices(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.viewOrderInvoices,
      obj
    );
  }
  getCustomerAllOrders(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getCustomerAllOrders,
      obj
    );
  }
  getCustomerAllMaterials(customerId, pageNo, pageSize): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getCustomerAllMaterials
      + "?customerId=" + customerId + "&pageNo=" + pageNo + "&pageSize=" + pageSize
    );
  }
  getCustomerAllInvoices(customerId, pageNo, pageSize): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getCustomerAllInvoices +
      "?customerId=" + customerId + "&pageNo=" + pageNo + "&pageSize=" + pageSize
    );
  }
  getCustomerContractUnits(customerId): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.getCustomerContractUnits + customerId)
  }
  getCustomerOrders(customerId): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.getCustomerOrders + customerId)
  }
  getContractDetails(contractId): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.getContractDetails + contractId)
  }

  getContractByIdUrl(contractId): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.getContractByIdUrl + contractId)
  }

  getContractViewForManualInvoice(contractId): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.getContractViewForManualInvoice + contractId)
  }



  searchContractByContractNumber(searchObj): Observable<any> {
    return this.http.post(myGlobals.BaseUrlOrderManagementNew + myGlobals.searchContractByContractNumber, searchObj);
  }
  getAllContrtManagerUsers(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.getAllContractManagerUsers
    );
  }
  postCustomer(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.postCustomerUrl,
      obj
    );
  }
  postCustomerFromWeb(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.postCustomerFromWebUrl,
      obj
    );
  }
  getCustomerDetails(customerId): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.getCustomerDetails + customerId)
  }
  ViewOrderDetails(orderId): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.viewOrderDetails + orderId)
  }
  GetAllMachinesByUnitId(unitId): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.GetAllMachinesByUnit + unitId)
  }
  ViewOrderImages(orderId): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.viewOrderImages + orderId)
  }

  viewOrderTasks(orderId: number): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.getOrderCompletedTasksGroupByProblem + orderId)
  }

  viewContractTasks(contractId: number, locationId: number): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.getContractPreventiveTasks + 'contractID=' + contractId + '&&locationId=' + locationId)
  }

  getOrderMaterialsInfo(orderId): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.getOrderMaterialsInfo + orderId)
  }

  getOrderMaterialsByOrderId(orderId: number, requestType: number): Observable<any> {
    return this.http.get(`${myGlobals.BaseUrlOrderManagementNew}${myGlobals.getOrderMaterialsByOrderId}${orderId}?materialRequestType=${requestType}`)
  }

  approvalOrderMaterial(body: object): Observable<any> {
    return this.http.post(`${myGlobals.BaseUrlOrderManagementNew}${myGlobals.approvalOrderMaterial}`, body);
  }
  getCheckRoleValidToApprove(orderId: number, levelNo: number): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.getCheckRoleValidToApprove + orderId + "/" + levelNo)
  }


  editOrderMaterials(body: object): Observable<any> {
    return this.http.post(`${myGlobals.BaseUrlOrderManagementNew}${myGlobals.editOrderMaterials}`, body);
  }
  sendOrderApprovalNotificationsToTechnician(body: object): Observable<any> {
    return this.http.post(`${myGlobals.BaseUrlOrderManagementNew}${myGlobals.sendOrderApprovalNotificationsToTechnician}`, body);
  }
  /**
   * customer addresses
   *
   *
   * @param customerId
   */
  getCustomerAddresses(customerId: number): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.customerAddresses + customerId)
  }

  getCustomerDetailsWithPagedLocations(customerId): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.getCustomerDetailsWithPagedLocations + customerId)
  }


  updateCustomer(customerData): Observable<any> {
    return this.http.put(myGlobals.BaseUrlOrderManagementNew + myGlobals.updateCustomerUrl, customerData)
  }



  AddCustomerAddress(customerData: LocationDataViewModel): Observable<Responce<Boolean>> {
    return this.http.post<Responce<Boolean>>(myGlobals.BaseUrlOrderManagementNew + myGlobals.AddCustomerAddress, customerData)
  }

  EditCustomerAddress(customerData: LocationDataViewModel): Observable<Responce<Boolean>> {
    return this.http.put<Responce<Boolean>>(myGlobals.BaseUrlOrderManagementNew + myGlobals.EditCustomerAddress, customerData)
  }

  SetAsPrimaryCustomerAddress(customerData: LocationDataViewModel): Observable<Responce<Boolean>> {
    return this.http.put<Responce<Boolean>>(myGlobals.BaseUrlOrderManagementNew + myGlobals.SetAsPrimaryCustomerAddress, customerData)
  }

  DeleteCustomerAddress(id: number): Observable<Responce<Boolean>> {
    return this.http.delete<Responce<Boolean>>(myGlobals.BaseUrlOrderManagementNew + myGlobals.DeleteCustomerAddress + id);
  }

  GetLastCustomerAddress(customerId: number): Observable<Responce<LocationDataViewModel>> {
    return this.http.get<Responce<LocationDataViewModel>>(myGlobals.BaseUrlOrderManagementNew + myGlobals.GetLastCustomerAddress + customerId);
  }


  get governorates(): Observable<any> {
    return this.http.get(myGlobals.BaseUrlUserManagementNew + myGlobals.getAllGovUrl);
  }
  allGovernorates(): Observable<any> {
    return this.http.get(myGlobals.BaseUrlUserManagementNew + myGlobals.getAllGovUrl);
  }

  getAreaByGov(govId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getAreaByGovUrl + govId

    );
  }
  getAreas(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getAllAreasUrl

    );
  }

  GetAreasByGovs(govIds: any[]): Observable<any> {
    return this.http.post(myGlobals.BaseUrlUserManagementNew + myGlobals.getAreaByGovsUrl, govIds);
  }

  //////////////////////////////////////////phones
  removeCustomerPhoneBook(id): Observable<any> {
    return this.http.delete(myGlobals.BaseUrlUserManagementNew + myGlobals.deleteCustomerPhoneBook + id)
  }
  getSearchCustomerAddress(obj): Observable<Responce<Pagination<LocationDataViewModel>>> {
    return this.http.post<Responce<Pagination<LocationDataViewModel>>>(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getSearchCustomerAddressUrl,
      obj
    );
  }
  getSearchAndGetAllCustomerAddress(obj): Observable<Responce<Pagination<LocationDataViewModel>>> {
    return this.http.post<Responce<Pagination<LocationDataViewModel>>>(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.SearchAndGetAllCustomerAddress,
      obj
    );
  }

  getSelectedLocationForOpportunity(opportunityId: number): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.SearchAndGetAllCustomerAddressForOpportunity + opportunityId

    );
  }
  getSelectedLocationForMCPotiential(mcPotentialId: number): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.SearchAndGetAllCustomerAddressForMcPotential + mcPotentialId

    );
  }
  getSelectedLocationForQuotation(quotaionId: number): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.SearchAndGetAllCustomerAddressForQuotaion + quotaionId

    );
  }


  searchCustomersReportByPaging(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.searchCustomersReportbyPaging,
      obj
    );
  }
  exportCustomersReportWithExcel(filterObj: any): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.exportCuatomersReportUrl, filterObj, { responseType: 'blob' }
    );
  }
  // contract status
  getAllContractStatus(): Observable<any> {
    return this.http.get(myGlobals.allContractStatus);
  }
  getAllContractStatusWithBlock(): Observable<any> {
    return this.http.get(myGlobals.allContractStatusWithBlock);
  }
  getAllContractStatusForFilter(): Observable<any> {
    return this.http.get(myGlobals.allContractStatusForFilter);
  }
  postContractStatusLanguages(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.postContractStatusLanguage,
      obj
    );
  }
  blockContractStatus(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.blockContractStatus + id
    );
  }
  getAllContractStatusWithoutLanguage(): Observable<any> {
    return this.http.get(myGlobals.allContractStatusWithOutlanguage);
  }
  // brands

  addBrand(obj): Observable<any> {

    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.AddBrand,
      obj
    );
  }
  updateBrand(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.EditBrand,
      obj
    );
  }
  blockBrand(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.blockBrand + id
    );
  }
  getAllBrands(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.BrandsList
    );
  }
  // search terms
  updateSearchTerm(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.EditSerachTerm,
      obj
    );
  }
  getSearchTermById(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.getSerachTermByIdUrl + id

    );
  }
  blockSearchTerm(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.blockSerachTerm + id
    );
  }
  getAllSearchTerms(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.SerachTermsList
    );
  }

  getAllSearchTermsListWithBlocked(): Observable<any> {
    return this.http.get(myGlobals.allSearchTermsListWithBlocked);
  }
  postSearchTermsLanguage(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.postSearchTermsLanguage,
      obj
    );
  }
  ////////////////////////////contractType

  getContractType(customerId): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.getContractType + customerId)
  }


  getSearchTermsPaginated(model): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.getSerachTermPaginatedIdUrl, model

    );
  }
  addSearchTerm(model): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.addSearchTermValueUrl, model

    );
  }
  removeSearchTerm(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.deleteSearchTermValueUrl + id

    );
  }













  // AreaIsExiste(obj): Observable<any> {
  //   return this.http.put(myGlobals.BaseUrlDataManagement + myGlobals.IsExistAreaUrl, obj);
  // }
  // AttendanceStatesIsExiste(obj): Observable<any> {
  //   return this.http.put(myGlobals.BaseUrlDataManagement + myGlobals.IsExistAttendanceStatesUrl, obj);
  // }
  // AvailabilityIsExiste(obj): Observable<any> {
  //   return this.http.put(myGlobals.BaseUrlDataManagement + myGlobals.IsExistAvailabilityUrl, obj);
  // }
  // BuildingTypesIsExiste(obj): Observable<any> {
  //   return this.http.put(myGlobals.BaseUrlDataManagement + myGlobals.IsExistBuildingTypesUrl, obj);
  // }
  // CompanyCodeIsExiste(obj): Observable<any> {
  //   return this.http.put(myGlobals.BaseUrlDataManagement + myGlobals.IsExistCompanyCodeUrl, obj);
  // }
  // ContractTypesIsExiste(obj): Observable<any> {
  //   return this.http.put(myGlobals.BaseUrlDataManagement + myGlobals.IsExistContractTypesUrl, obj);
  // }
  // CostCenterIsExiste(obj): Observable<any> {
  //   return this.http.put(myGlobals.BaseUrlDataManagement + myGlobals.IsExistCostCenterUrl, obj);
  // }
  // DivisionIsExiste(obj): Observable<any> {
  //   return this.http.put(myGlobals.BaseUrlDataManagement + myGlobals.IsExistDivisionUrl, obj);
  // }
  // GovernoratesIsExiste(obj): Observable<any> {
  //   return this.http.put(myGlobals.BaseUrlDataManagement + myGlobals.IsExistGovernoratesUrl, obj);
  // }
  // ShiftIsExiste(obj): Observable<any> {
  //   return this.http.put(myGlobals.BaseUrlDataManagement + myGlobals.IsExistShiftUrl, obj);
  // }
  // LanguagesIsExiste(obj): Observable<any> {
  //   return this.http.put(myGlobals.BaseUrlDataManagement + myGlobals.IsExistLanguagesUrl, obj);
  // }

  // private helper methods
  // private jwt():Observable<any> {
  //   // create authorization header with jwt token
  //   let currentUser = JSON.parse(localStorage.getItem('AlghanimCurrentUser'));
  //   if (currentUser && currentUser.data.token):Observable<any> {
  //     let headers = new Headers({ 'Authorization': 'bearer ' + currentUser.data.token });
  //     headers.append('Content-Type', 'application/json');
  //     return new RequestOptions({ headers: headers });
  //   }
  // }

  // // private helper methods
  // private jwtwithParams(params):Observable<any> {
  //   // create authorization header with jwt token
  //   let currentUser = JSON.parse(localStorage.getItem('AlghanimCurrentUser'));
  //   if (currentUser && currentUser.data.token):Observable<any> {
  //     let headers = new Headers({ 'Authorization': 'bearer ' + currentUser.data.token });
  //     headers.append('Content-Type', 'application/json');
  //     return new RequestOptions({ headers: headers, params: params });
  //   }
  // }

  // private jwtDoc():Observable<any> {
  //   // create authorization header with jwt token
  //   let currentUser = JSON.parse(localStorage.getItem('currentUser'));
  //   if (currentUser && currentUser.token.accessToken):Observable<any> {
  //     let headers = new Headers({'Authorization': 'bearer ' + currentUser.token.accessToken});
  //     headers.append('Content-Type', 'application/json');
  //     return new RequestOptions({headers: headers});
  //   }
  // }

  // private header():Observable<any> {
  //   // create authorization header with jwt token
  //   let currentUser = JSON.parse(localStorage.getItem('AlghanimCurrentUser'));
  //   if (currentUser && currentUser.data.token):Observable<any> {
  //     var headers = new Headers({ 'Authorization': 'bearer ' + currentUser.data.token });
  //     headers.append('Content-Type', 'application/json');
  //     return headers;
  //   }
  // }


  //////////////////////UOMs
  getAllUOMsWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.alUOMsLang
    );
  }

  addUOM(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.addUOMURL,
      obj
    );
  }
  blockUOM(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.blockUOM + id
    );
  }

  editUOM(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.putUOMLanguageUrl,
      obj
    );
  }

  ///////////Materials
  //Groups
  getGroupsList(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.GroupsList
    );
  }
  getAllGroupsWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.allGroupsLang
    );
  }

  addGroup(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.addGroup,
      obj
    );
  }
  blockGroup(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.blockGroup + id
    );
  }

  editGroup(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.putGroupLanguageUrl,
      obj
    );
  }

  //SubGroups
  getAllSubGroupsWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.allSubGroupsLang
    );
  }

  addSubGroup(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.addSubGroup,
      obj
    );
  }
  blockSubGroup(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.blockSubGroup + id
    );
  }

  editSubGroup(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.putSubGroupLanguageUrl,
      obj
    );
  }
  getContractsPaginated(contractsFilter: any): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.ContractsGetPaginated, contractsFilter
    );
  }
  getContractsPaginatedExpiredInAMonth(contractsFilter: any): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.GetPaginatedExpiredInAMonth, contractsFilter
    );
  }
  cancelContractInvoice(id: number, reason: string): Observable<Responce<boolean>> {
    return this.http.get<Responce<boolean>>(`${myGlobals.BaseUrlIdentity}${myGlobals.contractInvoicecancelUrl}` + id + '/' + reason);
  }

  getAllpaymentsForInvoice(id: any, isForManualInvoice: boolean): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getAllpaymentsForInvoice + id + '/' + isForManualInvoice
    );
  }

  addManualInvoiceDiscount(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.AddManualInvoiceDiscount,
      obj
    );
  }
  addContractInvoiceDiscount(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.AddContractInvoiceDiscount,
      obj
    );
  }
  addInvoicePayment(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.AddpaymentsForInvoice,
      obj
    );
  }
  generatePaymentGatewayLink(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.PaymentGateWayGenerateLink,
      obj
    );
  }
  paymentGatewayGetByEncryptedId(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.GetByEncryptedId, { "encryptId": obj });
  }
  PaymentGateWayPay(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.PaymentGateWayPay, obj);
  }
  PaymentGateWaysuccess(payment_type, paymentID, result, postDate, tranID, ref, trackID, auth, orderID, cust_ref, trnUdf): Observable<any> {

    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.PaymentGateWaysuccess + '?PaymentID=' + paymentID + '&Result=' + result + '&PostDate=' + postDate + '&TranID=' + tranID +
      '&Ref=' + ref + '&TrackID=' + trackID + '&Auth=' + auth + '&OrderID=' + orderID + '&cust_ref=' + cust_ref + '&trnUdf=' + trnUdf
    );
  }
  TapPaymentRedirect(id): Observable<any> {

    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.TapPaymentRedirect + '?Id=' + id);
  }
  SadadPaymentRedirect(invoiceId): Observable<any> {

    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.SadadPaymentRedirect + '?InvoiceId=' + invoiceId);
  }
  getPgFiltedReport(filterObj: any): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.PGGetFiltedReport, filterObj
    );
  }

  RemovePayments(obj): Observable<any> {

    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.RemovePayments,
      obj
    );
  }


  getAllOrderpaymentsForInvoice(id: any): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getAllOrderpaymentsForInvoice + id
    );
  }

  addOrderInvoicePayment(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.AddOrderpaymentsForInvoice,
      obj
    );
  }

  RemoveOrderPayments(obj): Observable<any> {

    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.RemoveOrderPayments,
      obj
    );
  }
  postNewManualInvoice(newInvoice): Observable<any> {
    return this.http.post(myGlobals.BaseUrlOrderManagementNew + myGlobals.generateManualInvoiceUrl, newInvoice)
  }

  updateMAnualInvocie(invocie): Observable<any> {
    return this.http
      .put(myGlobals.BaseUrlOrderManagementNew + myGlobals.updateManualInvoiceUrl, invocie)
  }


  UpdateManualInvoicePayment(invoice): Observable<any> {
    return this.http
      .put(myGlobals.BaseUrlOrderManagementNew + myGlobals.updateMAnualInvoicePaymentUrl, invoice)
  }

  UpdateManualInvoiceAnDelete(invoice): Observable<any> {
    return this.http
      .put(myGlobals.BaseUrlOrderManagementNew + myGlobals.updateManualInvoiceaAndDeleteUrl, invoice)
  }
  getManualInvoiceById(number): Observable<any> {
    return this.http
      .get(myGlobals.BaseUrlOrderManagementNew + myGlobals.getManualInvoiceById + number)
  }
  getContractInvoiceById(number): Observable<any> {
    return this.http
      .get(myGlobals.BaseUrlOrderManagementNew + myGlobals.getContractInvoiceById + number)
  }

  getManualInvoiceByCallId(number): Observable<any> {
    return this.http
      .get(myGlobals.BaseUrlOrderManagementNew + myGlobals.getManualInvoiceByCallId + number)

  }
  getManualInvoiceByContractId(number): Observable<any> {
    return this.http
      .get(myGlobals.BaseUrlOrderManagementNew + myGlobals.getManualInvoiceByContractId + number)
  }

  getManualInvoiceByContractIdByPaging(objToPost): Observable<any> {
    return this.http.post(myGlobals.BaseUrlOrderManagementNew + myGlobals.getManualInvoiceByContractIdByPaging, objToPost)
  }

  getManualInvoiceByCallIdByPaging(objToPost): Observable<any> {
    return this.http.post(myGlobals.BaseUrlOrderManagementNew + myGlobals.getManualInvoiceByCallIdByPaging, objToPost)
  }


  getAllMAnualInvoicesByPaging(objToPost): Observable<any> {
    return this.http.post(myGlobals.BaseUrlOrderManagementNew + myGlobals.getAllManualInvoicesByPagingUrl, objToPost)
  }
  getAllContractInvoicesByPaging(objToPost): Observable<any> {
    return this.http.post(myGlobals.BaseUrlOrderManagementNew + myGlobals.getAllContractInvoicesByPagingUrl, objToPost)
  }
  searchManualInvoiceDataByPaging(objToPost): Observable<any> {
    return this.http.post(myGlobals.BaseUrlOrderManagementNew + myGlobals.searchManualInvoiceData, objToPost);
  }
  getGroupsListForMaterials(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.GroupsListForMaterial
    );
  }

  exportOrder(model: any): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.exportingOrders,
      model, { responseType: 'blob' }

    );
  }
  ExportingTeamOrders(model: any): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.ExportingTeamOrders,
      model, { responseType: 'blob' }

    );
  }

  ExportingTeamOrdersAsClosedXml(model: any): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.ExportingTeamOrdersAsClosedXml,
      model, { responseType: 'blob' }

    );
  }


  getOrderReport(orderId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.ordersReport + `/${orderId}`
    );
  }

  //////////////////////UOMs
  // getAllUOMsWithBlock(): Observable<any> {
  //   return this.http.get(
  //     myGlobals.BaseUrlOrderManagementNew + myGlobals.alUOMsLang
  //   );
  // }

  // addUOM(obj): Observable<any> {
  //   return this.http.post(
  //     myGlobals.BaseUrlOrderManagementNew + myGlobals.addUOMURL,
  //     obj
  //   );
  // }
  // blockUOM(id): Observable<any> {
  //   return this.http.delete(
  //     myGlobals.BaseUrlOrderManagementNew + myGlobals.blockUOM + id
  //   );
  // }

  // editUOM(obj): Observable<any> {
  //   return this.http.put(
  //     myGlobals.BaseUrlOrderManagementNew + myGlobals.putUOMLanguageUrl,
  //     obj
  //   );
  // }

  //////////////////////Pmtasks
  // getAllPmTasks(): Observable<any> {
  //   return this.http.get(
  //     myGlobals.BaseUrlOrderManagementNew + myGlobals.getAllPmTasksUrl
  //   );
  // }


  getAllPmTasksWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getPmTasksUrl
    );
  }

  getAllTasksGroupByProblem(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getAllTasksGroupByProblem
    );
  }

  addPmTask(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.addPmTasksURL,
      obj
    );
  }

  blockPmTask(id): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.blockPmTasksUrl + id, {}
    );
  }

  editPmTask(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.editPmTasksUrl,
      obj
    );
  }
  searchCustomersByName(obj: any): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.searchCustomersbyName, obj
    );
  }
  OnholdContract(model: any): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.OnholdContract, model
    );
  }
  RemoveOrderImage(id): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.RemoveOrderImage + id, {}
    );
  }
  removeCustomerLocation(id): Observable<any> {
    return this.http.delete(myGlobals.BaseUrlUserManagementNew + myGlobals.deleteCustomerLocation + id)
  }

  RemoveOnHoldContract(id): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.RemoveOnHoldContract + id, {}
    );
  }
  postNewContract(contract: any): Observable<any> {
    //TODO : Observable<any> API
    return null;
  }

  //////////////////////////////////////// Order
  addOrder(obj, guestOrderId?): Observable<any> {
    let url = myGlobals.BaseUrlIdentity + myGlobals.addOrderUrl;
    if (guestOrderId) {
      url += ("?guestOrderId=" + guestOrderId)
    }

    return this.http.post(
      url,
      obj,
    );
  }
  checkIfOrderCanBeAddedOrNot(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlIdentity + myGlobals.CheckIfOrderCanBeAddedOrNot,
      obj
    );
  }
  addCallCenterUser(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.addCallCenterUser,
      obj
    );
  }
  editCallCenterUser(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.editCallCenterUser,
      obj
    );
  }
  getCallCenterUserByID(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getCallCenterUserById + id
    );
  }
  blockCallCenterUser(id): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.blockCallCenterUser + id, {}
    );
  }
  getAllCallCenterUsers(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getAllCallCenterUser
    );
  }
  getCallCenterRoles(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getAllCallCenterRoles
    );
  }
  getSupervisorCallCenterRoles(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getSupervisorCallCenterRoles
    );
  }
  getAllRolesWithPermissions(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getAllRolesWithPermissions,
      obj
    );
  }

  getAllRolesWithoutPagination(): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.getAllRoles);
  }

  AddRoleWithPermissions(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.addRoleWithPermissions,
      obj
    );
    //RolesAndPermissions
  }
  editRoleWithPermissions(obj): Observable<any> {
    //RolesAndPermissions
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.editRoleWithPermissions,
      obj
    );
  }
  getRoleWithPermissionsById(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getRoleWithPermissionsById + id
    );
  }
  //GetAllPermissionsGroupedByModule
  getAllPermissionsGroupedByModule(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getAllPermissionsGroupedByModule
    );
  }

  searchOrder(body: object): Observable<any> {
    return this.http.post(`${myGlobals.BaseUrlIdentity}${myGlobals.searchOrderUrl}`, body);
  }
  searchTeamOrder(body: object): Observable<any> {
    return this.http.post(`${myGlobals.BaseUrlIdentity}${myGlobals.searchTeamOrderUrl}`, body);
  }

  searchOrderByCode(number): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.searchOrderByCode + number);
  }
  searchOrderByCodeNotCancel(number): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.searchOrderByCodeNotCancel + number);
  }


  allOrders(body: object): Observable<any> {
    return this.http.post(`${myGlobals.BaseUrlIdentity}${myGlobals.getAllOrdersByPaging}`, body);
  }
  allGuestTempOrder(body: object): Observable<any> {
    return this.http.post(`${myGlobals.BaseUrlIdentity}${myGlobals.getAllGuestTempOrderPaging}`, body);
  }
  SearchGuestTempOrderByPaging(body: object): Observable<any> {
    return this.http.post(`${myGlobals.BaseUrlIdentity}${myGlobals.SearchGuestTempOrderByPaging}`, body);
  }
  ExportGuestOrders(body: object): Observable<any> {
    return this.http.post(`${myGlobals.BaseUrlIdentity}${myGlobals.ExportGuestTempOrder}`, body, { responseType: 'blob' });
  }
  GuestTempOrderAddOrderId(body: object): Observable<any> {

    return this.http.post(`${myGlobals.BaseUrlIdentity}${myGlobals.GuestTempOrderAddOrderId}`, body);
  }

  //Call request
  getAllCallRequestPaging(body: object): Observable<any> {
    return this.http.post(`${myGlobals.BaseUrlIdentity}${myGlobals.getAllCallRequestPaging}`, body);
  }
  SearchGuestCallRequestByPaging(body: object): Observable<any> {
    return this.http.post(`${myGlobals.BaseUrlIdentity}${myGlobals.SearchGuestCallRequestByPaging}`, body);
  }
  CallRequestAddDoneBy(body: object): Observable<any> {

    return this.http.post(`${myGlobals.BaseUrlIdentity}${myGlobals.CallRequestAddDoneBy}`, body);
  }

  ExportCallRequestOrders(body: object): Observable<any> {
    return this.http.post(`${myGlobals.BaseUrlIdentity}${myGlobals.ExportGuestCallRequestByPaging}`, body, { responseType: 'blob' });
  }






  /**
   * view order progress via order id
   *
   *
   * @param body
   */
  viewOrderProgress(body: object): Observable<any> {
    return this.http.post(`${myGlobals.BaseUrlIdentity}${myGlobals.viewOrderProgress}`, body);
  }

  /**
   * get order modification history log via order id
   *
   * @param orderId
   * @param pageNo
   * @param pageSize
   */
  getOrderHistoryLog(orderId: number, pageNo: number, pageSize: number): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getOrderHistoryLogUrl + orderId
      + "?pageNo=" + pageNo + "&pageSize=" + pageSize
    );
  }


  blockRoleWithPermission(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.blockRoleWithPermissions + id
    );
  }

  getTaxPercentage(): Observable<number> {
    return this.http.get<number>(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.GetTaxPercentage
    )//map((res:any) => <number>res.json());;
  }


  getContractManualInvoicePaginated(filter: any): Observable<Responce<Pagination<any>>> {
    return this.http.post<Responce<Pagination<any>>>(`${myGlobals.BaseUrlIdentity}${myGlobals.manualInvoiceGetPaginated}`, filter);
  }
  getAllAssignedOrdersForForeman(foremanId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.assignedOrdersForForemanUrl +
      foremanId
    );
  }
  cancelManualInvoice(id: number, reason: string): Observable<Responce<boolean>> {
    return this.http.get<Responce<boolean>>(`${myGlobals.BaseUrlIdentity}${myGlobals.manualInvoicecancelUrl}` + id + '/' + reason);
  }



  AddGerneralSettings(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.PostGeneralSettingsURL,
      obj
    );
  }
  SaveInvoiceSettings(obj): Observable<Responce<any>> {
    return this.http.put<Responce<any>>(
      myGlobals.BaseUrlDataManagement + myGlobals.SaveInvoiceSettings,
      obj
    );
  }
  SaveLabourSettings(obj): Observable<Responce<any>> {
    return this.http.put<Responce<any>>(
      myGlobals.BaseUrlDataManagement + myGlobals.SaveLabourSettings,
      obj
    );
  }

  GetGerneralSettings(id: number): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.GetGeneralSettingsURL + id
    );
  }

  getFormanTeamOrdersByTeamId(model: any): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.ForemanTeamOrdersUrl,
      model
    );
  }

  deleteFileUrl(path: string): Observable<any> {
    return this.http.delete(`${myGlobals.BaseUrlUserManagementNew}${myGlobals.deleteFileUrl}?fullPath=${path}`)
  }
  getFormanInDivision(id: number): Observable<any> {
    return this.http.get(myGlobals.BaseUrlDataManagement + myGlobals.getFormanInDivision + id);
  }

  getTeamIssueMaterial(body: object): Observable<any> {
    return this.http.post(myGlobals.BaseUrlDataManagement + myGlobals.getTeamIssueMaterial, body);
  }

  getTeamIssueMaterialLight(body: Object): Observable<any> {
    return this.http.post(myGlobals.BaseUrlDataManagement + myGlobals.getTeamIssueMaterialLight, body);
  }


  addTeamIssueMaterial(body: object): Observable<any> {
    return this.http.post(myGlobals.BaseUrlDataManagement + myGlobals.addTeamMaterialTransaction, body);
  }

  searchInIssueMaterialByPartNo(partNo: number, materialName, selectedTeamId: number): Observable<any> {
    return this.http.get(myGlobals.BaseUrlDataManagement + myGlobals.searchInIssueMaterialByPartNo + '?partNo=' + partNo + '&&materialName=' + materialName + '&&teamId=' + selectedTeamId);
  }
  getApprovalRoles(): Observable<any> {
    return this.http.get(myGlobals.BaseUrlIdentity + myGlobals.getApprovalCycleRolesURL);
  }


  getAllOrderStatus(): Observable<any> {
    return this.http.get(myGlobals.allOrderStatusUrl);
  }
  getAllOrderStatus2(): Observable<any> {
    return this.http.get(myGlobals.allOrderStatusUrl2);
  }



  ////////////////////// Request Reasons
  getAllRequestReasonsWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.allRequestReasonsLangUrl
    );
  }

  addRequestReasons(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.addRequestReasonURL,
      obj
    );
  }
  blockRequestReasons(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.blockRequestReasonUrl + id
    );
  }
  blockRequestReason(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.blockRequestReasonUrl2 + id
    );
  }
  editRequestReasons(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.putRequestReasonLanguageUrl,
      obj
    );
  }

  allusersThatCreatedOrdersAsLookUps(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.allusersThatCreatedOrdersAsLookUps
    );
  }
  //Home dashboard
  customerDataForDashboard(obj): Observable<any> {
    return this.http.post(myGlobals.BaseUrlDataManagement + myGlobals.customerDataDashboardUrl, obj)
  }
  contractDataForDashboard(obj): Observable<any> {
    return this.http.post(myGlobals.BaseUrlDataManagement + myGlobals.contractDataDashboardUrl, obj)
  }
  orderDataForDashboard(obj): Observable<any> {
    return this.http.post(myGlobals.BaseUrlDataManagement + myGlobals.OrderDataDashboardUrl, obj)
  }
  InvoicesDataForDashboard(obj): Observable<any> {
    return this.http.post(myGlobals.BaseUrlDataManagement + myGlobals.invoicesDataDashboardUrl, obj)
  }
  TeamsOrdersDashboard(obj): Observable<any> {
    return this.http.post(myGlobals.BaseUrlDataManagement + myGlobals.TeamsOrdersDashboardUrl, obj)
  }
  DispatcherOrdersDashboard(obj): Observable<any> {
    return this.http.post(myGlobals.BaseUrlDataManagement + myGlobals.DispatcherOrdersDashboardUrl, obj)
  }
  CallCenterOrdersDashboard(obj): Observable<any> {
    return this.http.post(myGlobals.BaseUrlDataManagement + myGlobals.UsersOrdersDashboardUrl, obj)
  }


  //dash board
  customerDashboard(obj): Observable<any> {
    return this.http.post(myGlobals.BaseUrlDataManagement + myGlobals.customerDashboardUrl, obj)
  }
  contractDashboard(obj): Observable<any> {
    return this.http.post(myGlobals.BaseUrlDataManagement + myGlobals.contractDashboardUrl, obj)
  }
  orderDashboard(obj): Observable<any> {
    return this.http.post(myGlobals.BaseUrlDataManagement + myGlobals.OrderDashboardUrl, obj)
  }
  OrderByDispDashboard(obj): Observable<any> {
    return this.http.post(myGlobals.BaseUrlDataManagement + myGlobals.OrderByDispDashboardUrl, obj)
  }
  OrderByTeamDashboard(obj): Observable<any> {
    return this.http.post(myGlobals.BaseUrlDataManagement + myGlobals.OrderByTeamDashboardUrl, obj)
  }
  InvoicesDashboard(obj): Observable<any> {
    return this.http.post(myGlobals.BaseUrlDataManagement + myGlobals.invoicesDashboardUrl, obj)
  }
  //tags

  getAllTagsWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getAllTagsUrl
    );
  }


  addTag(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.addTagUrl,
      obj
    );
  }

  blockTag(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.blockTagUrl + id, {}
    );
  }

  editTag(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.editTagUrl,
      obj
    );
  }
  saveTag(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.saveTagsUrl,
      obj
    );
  }

  getCustomerUnitesTaged(customerId): Observable<any> {
    return this.http.get(myGlobals.BaseUrlDataManagement + myGlobals.getCustomerUnitTagedUrl + customerId)
  }
  // getEvents() {
  //   return this.http.get('showcase/resources/data/calendarevents.json')
  //     .toPromise()
  //     .then(res => <any[]>res.json().data)
  //     .then(data => { return data; });
  // }

  getOrdersForCalendar(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getAllOrders,
      obj
    );
  }

  GuestTempOrderGetById(id): Observable<Responce<guestTempOrder>> {
    return this.http.get<Responce<guestTempOrder>>(
      myGlobals.BaseUrlDataManagement + myGlobals.GuestTempOrderGetById + id
    );
  }
  GetOrderIdByOrderGuestId(id): Observable<Responce<number>> {
    return this.http.get<Responce<number>>(
      myGlobals.BaseUrlDataManagement + myGlobals.GetOrderIdByOrderGuestId + id
    );
  }
  getCustomerTags(customerId): Observable<any> {
    return this.http.get(myGlobals.BaseUrlDataManagement + myGlobals.getCustomerTagedUrl + customerId)
  }
  postCustomerTags(model): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.postCustomerTagUrl, model
    );
  }
  deleteAllCustomerTags(models): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.deleteAllCustomerTagsUrl, models
    );
  }
  deleteCustomerTag(models): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.deleteCustomerTagUrl, models
    );
  }
  getCustomerAddressesByPaging(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.allCustomerAddressesByPaging,
      obj
    );
  }



  ManualInvoicePay(id: number): Observable<Responce<number>> {
    return this.http.get<Responce<number>>(
      myGlobals.BaseUrlDataManagement + myGlobals.ManualInvoicePay + id
    );
  }

  ManualInvoicePaymentVerify(encrp: string): Observable<Responce<any>> {
    return this.http.get<Responce<any>>(
      myGlobals.BaseUrlDataManagement + myGlobals.ManualInvoicePaymentVerify + encrp
    );
  }

  GetAccessTokenForMerchant(): Observable<Responce<any>> {
    return this.http.get<Responce<any>>(
      myGlobals.BaseUrlDataManagement + myGlobals.GetAccessTokenForMerchant
    );
  }
  PayObjectOfPayment(manualInvoiceId): Observable<Responce<any>> {
    return this.http.get<Responce<any>>(
      myGlobals.BaseUrlDataManagement + myGlobals.PayObjectOfPayment + manualInvoiceId
    );
  }

  getForemanGetAllWithParentIdsDto(): Observable<Responce<any[]>> {
    return this.http.get<Responce<any[]>>(
      myGlobals.BaseUrlDataManagement + myGlobals.getForemanGetAllWithParentIdsDto
    );
  }

  getContractInvoiceWithPayment(id: number): Observable<Responce<boolean>> {
    return this.http.get<Responce<boolean>>(`${myGlobals.BaseUrlIdentity}${myGlobals.getContractInvoiceWithPaymentUrl}` + id);
  }
  exportContractInvoiceWithPayment(id: number) {
    return this.http.get(`${myGlobals.BaseUrlIdentity}${myGlobals.exportContractInvoiceWithPaymentUrl}` + id, { responseType: 'blob' });
  }
  getManualInvoiceWithPayment(id: number): Observable<Responce<boolean>> {
    return this.http.get<Responce<boolean>>(`${myGlobals.BaseUrlIdentity}${myGlobals.getManualInvoiceWithPaymentUrl}` + id);
  }
  exportManualInvoiceWithPayment(id: number) {
    return this.http.get(`${myGlobals.BaseUrlIdentity}${myGlobals.exportManualInvoiceWithPaymentUrl}` + id, { responseType: 'blob' });
  }
  getTeamGetAllWithParentIdsDto(): Observable<Responce<any[]>> {
    return this.http.get<Responce<any[]>>(
      myGlobals.BaseUrlDataManagement + myGlobals.getTeamGetAllWithParentIdsDto
    );
  }
  getDispatcherGetAllAsLookUp(): Observable<Responce<any[]>> {
    return this.http.get<Responce<any[]>>(
      myGlobals.BaseUrlDataManagement + myGlobals.getDispatcherGetAllAsLookUp
    );
  }
  getOrderMaterialGetAllPaginatedForReport(filter): Observable<Responce<Pagination<any>>> {
    return this.http.post<Responce<Pagination<any>>>(
      myGlobals.BaseUrlDataManagement + myGlobals.getOrderMaterialGetAllPaginatedForReport, filter
    );
  }
  getOrderMaterialGetAllExportForReport(filter): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.getOrderMaterialGetAllExportForReport, filter, { responseType: 'blob' }
    );
  }
  GetAllExportForReportAsCloseXml(filter): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.GetAllExportForReportAsCloseXml, filter, { responseType: 'blob' }
    );
  }

  getCompanyProfileSettings(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.getCompanyProfileUrl
    );
  }
  saveCompanyProfile(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.saveCompanyProfileUrl,
      obj
    );
  }
  getCustomerSerialSettings(): Observable<any> {

    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.GetCustomerSerialUrl
    );
  }
  getContractAddressesByPaging(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.allContractAddressesByPaging,
      obj
    );
  }
  getTeamsByProblemId(id: number): Observable<any> {
    return this.http.get<Responce<any[]>>(
      myGlobals.BaseUrlDataManagement + myGlobals.getTeamsByProblemId + "?problemId=" + id
    );
  }
  getAllTeamsAsLookUp(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlUserManagementNew + myGlobals.getAllTeamsAsLookUpUrl
    );
  }
  teamAutoComplete(name): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.teamAutoCompleteUrl + name);
  }




  getContractTypeSettings(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getContractTypeSettingsUrl
    );
  }
  addContractTypeSettings(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.saveContractTypeSettingsUrl,
      obj
    );
  }
  getAllContractTypeSettings(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getAllContractTypeSettingsUrl
    );
  }
  unAssignMaterial(body: object): Observable<any> {
    return this.http.post(myGlobals.BaseUrlDataManagement + myGlobals.unassignMaterialTransaction, body);
  }
  ///lead
  getAllLeadsWithBlock(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.allLeadsLang
    );
  }

  addLeadGoal(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.addLeadGoalURL,
      obj
    );
  }
  blockLeadGoal(id): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.blockLeadGoal + id
    );
  }

  editLeadGoal(obj): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.putLeadGoalLanguageUrl,
      obj
    );
  }



  getTasksByProblemId(problemId): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getTasksByProblemUrl + `?problemId=${problemId}`
    );
  }
  saveOrderTasks(body): Observable<any> {
    return this.http.post(myGlobals.BaseUrlDataManagement + myGlobals.saveTasksProblemOrderUrl, body);
  }
  getOrderTasks(orderId: number): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.getOrderCompletedTasksUrl + orderId)
  }
  getAllCompeltedOrderProblems(orderId: number): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlOrderManagementNew + myGlobals.getOrderProblemsUrl + orderId
    );
  }
  updateCompletedOrderTasks(body): Observable<any> {
    return this.http.put(myGlobals.BaseUrlDataManagement + myGlobals.updateOrderCompletedTasksUrl, body);
  }
  updateCompletedOrderSurveyReport(body, orderId): Observable<any> {
    return this.http.put(myGlobals.BaseUrlDataManagement + myGlobals.updateOrderSurveyReportUrl + `/${orderId}`, body);
  }

  //terms and conditions
  getAllTerms(): Observable<any> {
    return this.http.get(`${myGlobals.BaseUrlIdentity}${myGlobals.getAllTermsUrl}`);
  }
  getByContractTypeId(contractTypeId: number): Observable<any> {
    return this.http.get(myGlobals.BaseUrlDataManagement + myGlobals.GetByContractTypeId + "/" + contractTypeId);
  }
  addTerms(objToPost: any): Observable<any> {
    return this.http.post(`${myGlobals.BaseUrlIdentity}${myGlobals.AddTermsUrl}`, objToPost);
  }
  updateTerms(objToPost: any): Observable<any> {
    return this.http.put(`${myGlobals.BaseUrlIdentity}${myGlobals.updateTermsUrl}`, objToPost);
  }
  getCustomerDeleteRequests(body: object): Observable<any> {
    return this.http.post(myGlobals.BaseUrlDataManagement + myGlobals.getCustomerDeleteRequestsUrl, body);
  }
  approveDeleteCustomerRequest(body: object): Observable<any> {
    return this.http.put(myGlobals.BaseUrlDataManagement + myGlobals.approveDeleteCustomerRequestUrl, body);
  }
  rejectDeleteCustomerRequest(body: object): Observable<any> {
    return this.http.put(myGlobals.BaseUrlDataManagement + myGlobals.rejectDeleteCustomerRequestUrl, body);
  }

  exportingOrdersToEmail(model: any, header?): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.exportingOrdersToEmail,
      model, header

    );
  }
  ExportingOrdersAsCloseXmlToEmail(model: any, header?): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.exportingOrdersAsCloseXmlToEmail,
      model, header

    );
  }


  exportingPGToEmail(model: any, header?): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.ExportingPGToEmail,
      model, header

    );
  }
  ExportingExcelPGToEmailAsCloseXML(model: any, header?): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.ExportingExcelPGToEmailAsCloseXML,
      model, header

    );
  }

  sendEmail(model: any): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.sendEmail,
      model

    );
  }
  sendSms(model: any): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.sendSms,
      model

    );
  }

  getByIdWithEmail(id): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlIdentity + myGlobals.getByIdWithEmail + id
    );
  }

  editEmail(Email): Observable<any> {

    return this.http.put(myGlobals.BaseUrlIdentity + myGlobals.editEmailUrl, { Email: Email });
  }

  exportingCustomerReportToEmail(model: any, header?): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.exportingCustomerReportToEmail,
      model, header

    );
  }

  exportingCustomersReportWay(model: any): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.exportingCustomersReportWay,
      model

    );
  }


  exportingOrderstWay(model: any): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.exportingOrdersReportWay,
      model

    );
  }

  exportingPGWay(model: any): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.ExportingPGWay,
      model

    );
  }

  exportOrdersManagementReportToEmail(obj): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlOrderManagementNew +
      myGlobals.exportOrdersManagementReportToEmail,
      obj
    );
  }

  updatePreventiveMaintanceOrders(model: any): Observable<any> {
    return this.http.put(
      myGlobals.BaseUrlDataManagement + myGlobals.updatePreventiveMaintanceOrders,
      model

    );
  }
  DeletePaymentTransaction(id): Observable<any> {
    return this.http.delete(myGlobals.BaseUrlUserManagementNew + myGlobals.deletePaymentTransactionUrl + id)
  }
  getArchivedContractsPaginated(contractsFilter: any): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.archivedContractsGetPaginatedUrl, contractsFilter
    );
  }
  getReportLookUps(): Observable<any> {
    return this.http.get(
      myGlobals.BaseUrlDataManagement + myGlobals.getReportLookUps
    );
  }
  getContractContractsRevenueAllocation(contractsFilter: any): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.getContractContractsRevenueAllocation, contractsFilter
    );
  }
  exportingContractsRevenueAllocationToEmail(contractsFilter: any, header?): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.exportingContractsRevenueAllocationToEmail, contractsFilter, header
    );
  }

  exportingContractsRevenueAllocationAsClosedXmlToEmail(contractsFilter: any, header?): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.exportingContractsRevenueAllocationAsClosedXmlToEmail, contractsFilter, header
    );
  }



  exportingContractsRevenueAllocationWay(contractsFilter: any): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.exportingContractsRevenueAllocationWay, contractsFilter
    );
  }

  getAllTeamIssueMaterial(body: object): Observable<any> {
    return this.http.post(myGlobals.BaseUrlDataManagement + myGlobals.getAllTeamIssueMaterial, body);
  }

  getAllTeamIssueMaterialLight(body: object): Observable<any> {
    return this.http.post(myGlobals.BaseUrlDataManagement + myGlobals.getAllTeamIssueMaterialLight, body);
  }

  getAllUserExportedFiles(obj: any): Observable<any> {
    return this.http.post(
      myGlobals.BaseUrlDataManagement + myGlobals.getUserExportedFilesUrl, obj
    );
  }
  GetContractDataByContractNumberForGeneratManualInvoice(contractId): Observable<any> {
    return this.http.get(myGlobals.BaseUrlOrderManagementNew + myGlobals.GetContractDataByContractNumberForGeneratManualInvoiceUrl + contractId)
  }

  getAllShift(): Observable<any> {
    return this.http.get(myGlobals.BaseUrlDataManagement + myGlobals.shiftGetAllUrl);
  }

  deleteFile(fileId: number): Observable<any> {
    return this.http.delete(
      myGlobals.BaseUrlDataManagement + myGlobals.deleteFilesUrl + fileId
    );
  }

}

export class Responce<T> {
  isSucceeded: boolean;
  methodName: string;
  status: { code: number, subcode: number, message: "string" };
  data: T;
}
export class Pagination<T> {
  pageNo: number;
  pageSize: number;
  count: number;
  data: T[]
}
